import { HttpAuth } from '../../config/Http'

export const actionTypes = {
    INDEX: 'REPORTS_WHATSAPP_INDEX',
    CHANGE: 'REPORTS_WHATSAPP_CHANGE',
    SUCCESS: 'REPORTS_WHATSAPP_SUCCESS',
    ERROR: 'REPORTS_WHATSAPP_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const index = () => dispatch => {
    return HttpAuth.get('/reports-whatsapp')
            .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
}